'use strict';

angular.module('user')
    .controller('ApiAuthSignupPendingController', function() {
        var vm = this;
    });
